import { render, staticRenderFns } from "./FilterChipsComponent.vue?vue&type=template&id=26761f4a&scoped=true&"
import script from "./FilterChipsComponent.vue?vue&type=script&lang=ts&"
export * from "./FilterChipsComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26761f4a",
  null
  
)

export default component.exports